export default {

    TextTypes: [
		{ Id: 1, Text: 'Любой текст' },
		{ Id: 2, Text: 'Текст совпадает с' }
	],

	NumberTypes: [
		{ Id: 10, Text: 'Число равно' },
		{ Id: 11, Text: 'Число больше' },
		{ Id: 12, Text: 'Число меньше' }
	],

	SelectTypes: [
		{ Id: 20, Text: 'Ответ выбран' },
		{ Id: 21, Text: 'Ответ не выбран' }
	],

	ContactTypes: [
		{ Id: 30, Text: 'Контакт выбран' }
	],

	BoolTypes: [
		{ Id: 40, Text: 'Выбрано да' },
		{ Id: 41, Text: 'Выбрано нет' }
	],

	AepTypes: [
		{ Id: 100, Text: 'AEP/SKU выбран' },
		{ Id: 101, Text: 'AEP/SKU не выбран' }
    ]
}